import { render, staticRenderFns } from "./AddProcessModal.vue?vue&type=template&id=39a9d574&"
import script from "./AddProcessModal.vue?vue&type=script&lang=js&"
export * from "./AddProcessModal.vue?vue&type=script&lang=js&"
import style0 from "./AddProcessModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports